import React from 'react';
import { Form, Header, FormDropdown, Accordion, AccordionTitle, Icon, AccordionContent, Divider, Grid } from 'semantic-ui-react';
import ConstOrFile from './ConstOrFile';
import GSFInput from './GSFInput';
import IFACEBounds from './IFACEBounds';
import HelpButton from './HelpButton';
import HelpLabel from './HelpLabel';

let context = require('../mp3du_context.json');

class ModelSettings extends React.Component {
  constructor(props) {
		super(props);
    this.state = {activeIndex: 0};

    this.handleUpdate = this.handleUpdate.bind(this);
  }

  handleUpdate(e,d) {
    const modeltype = Object.keys(this.props.primary["FLOW_MODEL_TYPE"])[0];
    const target = ["FLOW_MODEL_TYPE", modeltype, d.name];
    let value = d.value;
    if (d.type === 'int') {
      value = parseInt(value);
    }
    this.props.onChange(target, value);
  }

  handleOptionsClick = (e, titleProps) => {
    const { index } = titleProps
    const { activeIndex } = this.state
    const newIndex = activeIndex === index ? -1 : index
    this.setState({ activeIndex: newIndex })
  }

  getDefault(obj,name) {
    return obj[name] === undefined ? "" : obj[name];
  }

  render() {
    const primary = this.props.primary;
    const options = this.props.options;
    const { activeIndex } = this.state;
    const modeltype = Object.keys(primary["FLOW_MODEL_TYPE"])[0];

    // MODFLOW
    if (modeltype === "MODFLOW") {
      // Current values
      const current = primary["FLOW_MODEL_TYPE"]["MODFLOW"];
      // Why did namefile need a null value instead of undefined? Did it?
      const namefile = this.getDefault(current,'NAME_FILE');
      const gsffile = this.getDefault(current,"GSF_FILE");
      const ifbounds = current['IFACE'];
      // Menu items
      const precision = options.precision.map((lab,index) =>
        ({key: index, text: lab, value: lab}));
      const threads = options.threads.map((lab,index) =>
        ({key: index, text: lab, value: lab}));
//label='Name File'
      return(
        <div>
          <Form.Input name="NAME_FILE" label='Name File' inline
          onChange={this.handleUpdate} value={namefile} className='inlineFine'/>
          <HelpButton hint={context["NAME_FILE"]} />

          <Divider hidden className='thinMan' />

          <GSFInput onChange={this.handleUpdate} value={gsffile} />
          <HelpButton hint={context["GSF_FILE_NAME"]} />

          <Divider hidden className='thinMan' />

          <HelpLabel text='IFACE Boundary Conditions' hint={context["IFACE"]} />
          <IFACEBounds boundaries={options.boundaries} iface={options.iface}
                       defaultValue={ifbounds} onChange={this.handleUpdate} />

          <Divider hidden />
          <Accordion styled>
            <AccordionTitle active={activeIndex === -1} index={0} onClick={this.handleOptionsClick}>
              <Icon name='dropdown' />Optional Settings
            </AccordionTitle>
            <AccordionContent active={activeIndex === -1}>
              <Form.Dropdown label='Output Precision' inline options={precision} selection
                            value={this.getDefault(current,"OUTPUT_PRECISION")}
                            onChange={this.handleUpdate}
                            name="OUTPUT_PRECISION" className='inlineFine'/>
              <HelpButton hint={context["OUTPUT_PRECISION"]} />

              <Divider hidden className='thinMan' />

              <Form.Dropdown inline label='Threads to Process CBC File' selection compact
                             options={threads} name="THREAD_COUNT"
                             value={this.getDefault(current,"THREAD_COUNT")}
                             onChange={this.handleUpdate} type='int' className='inlineFine'/>
              <HelpButton hint={context["THREAD_COUNT_MODFLOW"]} />
            </AccordionContent>
          </Accordion>
        </div>
      );
    }

    // MEUK
    if (modeltype === "MEUK") {
            // Current values
      const current = primary["FLOW_MODEL_TYPE"]["MEUK"];
      const gsffile = this.getDefault(current,"GSF_FILE");
      const meukopts = options.meukopts.map((lab,index) =>
        ({key: index, text: lab, value: lab}));
      return(
        <div>
          <Grid columns={2}>
            <Grid.Row>
              <Grid.Column width={7}>
                <Form.Input label='Grid Columns' />
              </Grid.Column>
              <Grid.Column width={7} floated='left'>
                <Form.Input label='Grid Rows' />
              </Grid.Column>
            </Grid.Row>
          </Grid>
          <GSFInput onChange={this.handleUpdate} value={gsffile} />
          <Header size="tiny">Horizontal Hydraulic Conductivity</Header>
          <ConstOrFile property="HHK"/>
          <Header size="tiny">Porosity</Header>
          <ConstOrFile property="POROSITY"/>
          <Divider hidden={true} />
          <Form.Input width={6} inline label='Search Radius' />
          <FormDropdown label="Options" selection multiple placeholder='Select one or more' options={meukopts}/>
        </div>
      );
    }
  }
}

export default ModelSettings;